// Bugsnag `onError` filter used to suppress expected/unactionable errors.
//
// HTTP 401 Unauthorized responses are handled by `unauthorizedMiddleware`,
// which clears the session and redirects the user to `/signin`. The superagent
// promise still rejects, and because several process thunks don't attach a
// `.catch()`, Bugsnag captures the rejection as an unhandled error before the
// navigation completes — producing noise that isn't actionable.
//
// This filter drops those events. Returning `false` tells Bugsnag to discard
// the event; returning `true` lets it through normally.
const AUTH_REDIRECT_MESSAGE_PATTERN = /login ou se registrar/;

export default function bugsnagShouldReport(event) {
  const originalError = event?.originalError;

  if (originalError?.status === 401) return false;
  if (originalError?.response?.status === 401) return false;

  const message = event?.errors?.[0]?.errorMessage;
  if (message && AUTH_REDIRECT_MESSAGE_PATTERN.test(message)) return false;

  return true;
}
